import { render, staticRenderFns } from "./publishEditor.vue?vue&type=template&id=a590e5e2&scoped=true"
import script from "./publishEditor.vue?vue&type=script&lang=js"
export * from "./publishEditor.vue?vue&type=script&lang=js"
import style0 from "./publishEditor.vue?vue&type=style&index=0&id=a590e5e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a590e5e2",
  null
  
)

export default component.exports